/**
 * @author jzhu 2019-12-31
 * 查看人员信息
 */
import React from "react";
import { connect } from "dva";
import { modelUtils } from "../../../../utils";
import "@/styles/containers/personManage/personInfoDetail/index.less";
import { createColumns, scopeWizTableColumns } from "./columns";
import { component_tool, framework_tool, utils_tool } from "../../../../tool";

let {
  WizCard,
  WizCollapse,
  WizRow,
  WizSpin,
  WizCol,
  WizTypography,
  WizDataTable,
  WizTabs,
  WizAlert,
  WizIcon,
} = component_tool;
let { WizContainer } = framework_tool;
let { Session, getPageData } = utils_tool

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
      if (history.location.record) {
        record = history.location.record
        Session.set('personInfoDetail', record)
      } else {
        record = Session.get('personInfoDetail') || {}
      }
  }
  return record
}

class PersonInfoDetail extends WizContainer {
  componentName = "PersonInfoDetail";

  constructor(props) {
    super(props);
    this.buildActionKey();
    let { history } = props
    let defaultStatus = {
      record: null,
      visible: false,
      selectedRows: 0,
      keys: [],
      rows: []
    }
    this._person = getParamRecord(history)
    this._personId = this._person.personId
    this.state = {
      modalKey: '',
      7: { ...defaultStatus },
      6: { ...defaultStatus }
    }
  }

  _componentDidMount = () => {
    this._getPersonData()
    let keys = [
      7,
      6
    ]
    keys.forEach(key => this._getOrgAuthorityInfo(key))
  }


  _getPersonData() {
    this.doAction({
      path: 'personInfo/getPersonData',
      payload: {
        key: 'personData@' + this._personId,
        apiParams: { personId: this._personId }
      }
    })
  }

  _renderTitleInfoRow(leftName, leftValue = '', rightName, rightValue = '') {
    return (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
        <WizCol className='text_right' span={3} offset={2}>{rightName + '：'}</WizCol>
        <WizCol span={6}>{rightValue}</WizCol>
      </WizRow>
    )
  }

  _render() {
    const { info, personInfoLoading } = this.props;
    let { user = {}, personInfo = {}, userIdentityInfoList = [] } = info.data
    if(user.mobile !== ''&& user.mobile !== null && user.mobile !== undefined) {
      user.mobile=user.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
    }
    let columns = createColumns(this)
    let dataTableProps = {
      loading: personInfoLoading,
      columns,
      rowKey: "personId",
      dataItems: { list: userIdentityInfoList },
      showNum: false,
      isScroll: true
    }
    let userTypeEnum =  {
      0: '培训平台用户',
      3: 'OEM部门用户',
      4: '经销商用户',
      5: '服务商用户'
      // 5 : 'FSE',
    }
    return (
      <>
        <WizCard title={'人员基本信息'}>
          {this._renderTitleInfoRow('账号', user.userName, '姓名', personInfo.fullName)}
          {this._renderTitleInfoRow('昵称',personInfo.nickName,'用户属性', userTypeEnum[personInfo.userType] || '未知' )}
          {this._renderTitleInfoRow('性别', personInfo.gender === 0 ? '男' : personInfo.gender === 1 ? '女' : '未知', '手机号', user.mobile)}
          {this._renderTitleInfoRow('邮箱', user.email, '状态', personInfo.state === 1 ? '激活' : '禁用')}
        </WizCard>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey="1">
            <WizTabs.TabPane tab="任职信息" key="1">
              <WizDataTable {...dataTableProps} />
            </WizTabs.TabPane>
            {this._renderAuthority()}
          </WizTabs>
        </WizCard>
      </>
    )
  }

  getIdCardStr = (userType) => {
    // if (userType === 1 || userType === 2 || userType === 5) {
    //   return '工号'
    // }
    return '证件号码'
  }

  _getOrgAuthorityInfo(managerType, apiParams = {}) {
    if (this.state[managerType] && this.state[managerType].selectedRows > 0) {
      this._onSelect([], [], managerType)
    }
    this.doAction({
      path: 'orgAuthority/getOrgAuthorityInfo',
      payload: {
        key: managerType + '@' + this._person.personId,
        apiParams: { managerType, current: 1, size: 10, personId: this._person.personId, ...apiParams }
      }
    })
  }

  _getType(key) {
    let types = {
      6: 'AdministrationSubjectToOrgPositionCategory',
      7: 'AdministrationSubjectToOrgPosition'
    }
    return types[key]
  }

  _renderSearchTable(key, title) {
    const { orgAuthorityLoading } = this.props;
    let type = this._getType(key)
    let { record, visible, selectedRows, rows } = this.state[key]
    let other = {
      type
    }
    let columns = scopeWizTableColumns(this, other)
    let searchBarProps = {
      columns,
      onSearch: values => this._getOrgAuthorityInfo(key, values)
    }
    let dataTableProps = {
      columns,
      rowKey: 'id',
      dataItems: getPageData(this.props[type] && this.props[type].data),
      showNum: false,
      isScroll: true,
      loading: orgAuthorityLoading,
      onChange: ({ pageNum, pageSize }) => {
        this._getOrgAuthorityInfo(key, { current: pageNum, size: pageSize })
      },
      selectedRowKeys: rows.map(item => item.rowKey),
    }
    let modalFormProps = {
      record,
      visible,
      columns,
      modalOpts: {
        width: 700
      },
      onCancel: () => this._setModalStatus(key, null, false),
      onSubmit: values => {
        this._setModalStatus(key, null, false)
        this._createOrgAuthority(key, values)
      }
    }
    return (
      <WizCollapse.Panel key={key} header={title} className='panel-item'>
        <WizCard>
          <WizDataTable key={key + '_dataTable'} {...dataTableProps} />
          <div className='pagination'>
            <WizDataTable.Pagination key={key + '_pagination'} {...dataTableProps} />
          </div>
        </WizCard>
      </WizCollapse.Panel>
    )
  }

  _renderAuthority() {
    if (this._person.showAuthority !== false) {
      return (
        <WizTabs.TabPane tab="用户权限" key="2">
          <WizCard>
            <WizCollapse className='administrationScope-collapse'
              expandIconPosition='right'
              defaultActiveKey={[
                7,
                6
              ]}
            >
              {this._renderSearchTable(7, '管理组织岗位')}
              {this._renderSearchTable(6, '管理组织岗位分类')}
            </WizCollapse>
          </WizCard>
        </WizTabs.TabPane>
      )
    }
    return null
  }
}

const mapStateToProps = (state, ownProps) => {
  const { personInfo, orgAuthority } = state;
  const { history } = ownProps
  let person = getParamRecord(history)
  const AdministrationSubjectToOrgPosition = modelUtils.getModelEntity(orgAuthority, '7@' + person.personId)
  const AdministrationSubjectToOrgPositionCategory = modelUtils.getModelEntity(orgAuthority, '6@' + person.personId)
  const info = modelUtils.getModelEntity(personInfo, 'personData@' + person.personId);
  const load = modelUtils.getLoadingState(state, 'personInfo', 'orgAuthority');
  return {
    info,
    ...load,
    AdministrationSubjectToOrgPosition,
    AdministrationSubjectToOrgPositionCategory,
  }
};

export default connect(mapStateToProps)(PersonInfoDetail);
